export const msalConfig = {
  auth: {
    clientId: "1cea1914-b9e3-4f30-bd04-360274f20ae8",
    authority: "https://login.microsoftonline.com/3154b850-3937-40b2-b0a3-40e1943b285a",  // 👈 Tenant específico
    redirectUri: "https://desarrollo.jaimeillanes.cl"
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  }
};

export const loginRequest = {
  scopes: ["User.Read"],
  prompt: "select_account",  // 👈 Fuerza siempre mostrar login
};
